import {useMutation, useQuery} from 'react-query'
import { getImageRulesResult } from '../api'

const useFetchImageRulesResult = () =>
    useMutation(getImageRulesResult)

export default useFetchImageRulesResult
